<nz-spin [nzSpinning]="loading$ | async">
  <form
    [formGroup]="organizationForm"
    (ngSubmit)="onSubmit($event)"
    nz-form
    class="add-org-form form"
    nzLayout="vertical">
    <div class="drawer-form-wrapper">
      <nz-form-item>
        <nz-form-label nzFor="orgname" [nzRequired]="!isViewMode"
          >Organization Name</nz-form-label
        >
        <nz-form-control [nzErrorTip]="orgNameError">
          <input
            type="text"
            nz-input
            id="orgname"
            formControlName="orgname"
            placeholder="Enter the organization name" />
          <ng-template #orgNameError let-control>
            <div class="error-message" *ngIf="control.errors">
              <span *ngIf="control.errors?.['required']">
                Please enter Organization Name
              </span>
              <span
                *ngIf="
                  !control.errors?.['required'] && control.errors?.['minlength']
                ">
                Organization name must be at least 5 characters
              </span>
              <span
                *ngIf="
                  !control.errors?.['required'] &&
                  !control.errors?.['minlength'] &&
                  control.errors?.['pattern']
                ">
                Organization name can't include special characters
              </span>
            </div>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="orgadd" [nzRequired]="!isViewMode"
          >Address</nz-form-label
        >
        <nz-form-control [nzErrorTip]="orgAddressError">
          <ng-container
            *ngIf="orgParams.mode !== OrganizationMode.VIEW; else viewMode">
            <input
              name="warningValid"
              type="text"
              nz-input
              id="orgadd"
              formControlName="orgadd"
              placeholder="Enter the street address" />
          </ng-container>

          <ng-template #viewMode>
            <input
              name="warningValid"
              type="text"
              nz-input
              id="orgadd"
              [disabled]="orgParams.mode === OrganizationMode.VIEW"
              [value]="fullAddress" />
          </ng-template>

          <ng-template #orgAddressError let-control>
            <ng-container *ngIf="control.hasError('required')">
              Please enter Organization Address
            </ng-container>
            <ng-container *ngIf="control.hasError('minlength')">
              Organization Address must be at least 5 characters
            </ng-container>
            <ng-container *ngIf="control.hasError('pattern')"
              >Spaces are not allowed at the start or end.</ng-container
            >
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-row [nzGutter]="16">
        <nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label nzFor="orgzipcode" [nzRequired]="!isViewMode"
              >Postal/Zip Code</nz-form-label
            >
            <nz-form-control [nzErrorTip]="orgZipCodeError">
              <input
                #postalCodeInput
                nz-input
                id="orgzipcode"
                formControlName="orgzipcode"
                placeholder="Enter the zip code"
                (keypress)="numberOnly($event)"
                (input)="onZipCodeChange($event)" />
              <ng-template #orgZipCodeError let-control>
                <div class="error-message">
                  <ng-container
                    *ngIf="control.errors?.['required']; else patternError">
                    Please enter Organization Zip Code
                  </ng-container>
                  <ng-template #patternError>
                    <ng-container *ngIf="control.errors?.['pattern']">
                      Please enter valid zip code (numbers only, 1-10 digits)
                    </ng-container>
                  </ng-template>
                </div>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </nz-col>

        <nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label nzFor="orgcountry" [nzRequired]="!isViewMode"
              >Country</nz-form-label
            >
            <nz-form-control [nzErrorTip]="orgCountryError">
              <nz-select
                nzShowSearch
                nzAllowClear
                formControlName="orgcountry"
                nzPlaceHolder="Select the country"
                [nzOptionOverflowSize]="7">
                <nz-option
                  *ngFor="let country of countries"
                  [nzLabel]="country.name"
                  [nzValue]="country.name">
                </nz-option>
              </nz-select>
              <ng-template #orgCountryError let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please select Organization Country
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-row [nzGutter]="16">
        <nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label nzFor="orgstate" [nzRequired]="!isViewMode"
              >State/Province</nz-form-label
            >
            <nz-form-control [nzErrorTip]="orgStateError">
              <nz-select
                nzShowSearch
                nzAllowClear
                formControlName="orgstate"
                [disabled]="isViewMode"
                [(ngModel)]="organizationData.state"
                nzPlaceHolder="Select the state"
                [nzOptionOverflowSize]="7">
                <nz-option
                  *ngFor="let state of states"
                  [nzLabel]="state.name"
                  [nzValue]="state.name">
                </nz-option>
              </nz-select>
              <ng-template #orgStateError let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please select Organization State
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </nz-col>

        <nz-col [nzSpan]="12">
          <nz-form-item>
            <nz-form-label nzFor="orgcity" [nzRequired]="!isViewMode"
              >City</nz-form-label
            >
            <nz-form-control [nzErrorTip]="orgCityError">
              <input
                nz-input
                id="orgcity"
                formControlName="orgcity"
                placeholder="Enter the city name" />
              <ng-template #orgCityError let-control>
                <ng-container *ngIf="control.hasError('required')">
                  Please enter Organization City
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
      </nz-row>

      <app-search-select
        label="Parent Organization"
        inputId="orgparentorg"
        [control]="organizationForm.get('orgparentorg')"
        [isEditMode]="isEditMode"
        [isParentOrganization]="true"
        [currentValue]="organizationData.parentOrganizationName"
        [isViewMode]="isViewMode"
        [optionOverflowSize]="7"
        placeholder="Select the parent organization"
        noDataText="No organizations found"
        requiredErrorMessage="Please enter Parent Organization"
        lookupType="ParentOrganization"></app-search-select>

      <nz-row [nzGutter]="16">
        <nz-col [nzSpan]="8">
          <nz-form-item>
            <span nz-checkbox formControlName="active" class="custom-checkbox"
              >Active</span
            >
          </nz-form-item>
        </nz-col>
        <nz-col [nzSpan]="8">
          <nz-form-item>
            <span nz-checkbox formControlName="trial" class="custom-checkbox"
              >Trial</span
            >
          </nz-form-item>
        </nz-col>
      </nz-row>

      <nz-form-item>
        <nz-form-label nzFor="orgproductname">Product Name</nz-form-label>
        <nz-form-control [nzErrorTip]="productNameError">
          <input
            name="warningValid"
            type="text"
            nz-input
            id="orgproductname"
            formControlName="orgproductname"
            placeholder="Enter the product name" />
          <ng-template #productNameError let-control>
            <div class="error-message" *ngIf="control.errors">
              <span *ngIf="control.errors?.['pattern']">
                Product name can't include special characters
              </span>
            </div>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <div
          class="text-btn-wrapper"
          *ngIf="orgParams.mode !== OrganizationMode.CREATE">
          <button
            type="button"
            nz-button
            nzType="text"
            class="primary-text-btn"
            (click)="openOrganizationDrawer()">
            Manage Organization
          </button>
          <button
            type="button"
            nz-button
            nzType="text"
            class="primary-text-btn"
            (click)="openAdministratorsDrawer()">
            Administrators
          </button>
          <button
            type="button"
            nz-button
            nzType="text"
            class="primary-text-btn"
            (click)="loadContactData()">
            Contact
          </button>
        </div>
      </nz-form-item>

      <div class="display-flex justify-content-between drawer-footer">
        <button
          type="button"
          nz-button
          nzType="default"
          (click)="closeOrganizationDrawer()">
          Cancel
        </button>

        <ng-container [ngSwitch]="true">
          <button
            *ngSwitchCase="isViewMode"
            type="button"
            nz-button
            nzType="primary"
            (click)="onEditOrganization()">
            Edit
          </button>

          <button
            *ngSwitchCase="
              isEditMode || orgParams.mode === OrganizationMode.CREATE
            "
            nz-button
            nzType="primary"
            [disabled]="!organizationForm.valid"
            [nzLoading]="loading$ | async">
            {{ orgParams.mode === OrganizationMode.CREATE ? 'Submit' : 'Save' }}
          </button>
        </ng-container>
      </div>
    </div>
  </form>
</nz-spin>

<ng-template #drawerTitleTpl>
  <div class="drawer-title-wrapper">
    <div class="back-button">
      <button nz-button nzType="default" type="button">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.8327 7.00033H1.16602M1.16602 7.00033L6.99935 12.8337M1.16602 7.00033L6.99935 1.16699"
            stroke="currentColor"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>
    <div>
      <h3 class="ant-drawer-title">Manage Organization</h3>
      <nz-breadcrumb nzSeparator=">">
        <nz-breadcrumb-item *ngIf="organizationData.parentOrganizationName">
          <span>{{ organizationData.parentOrganizationName }}</span>
        </nz-breadcrumb-item>
        <nz-breadcrumb-item>
          <a
            tabindex="0"
            (click)="closeManageOrgDrawer()"
            (keydown.enter)="closeManageOrgDrawer()"
            >{{ organizationData.organizationName }}</a
          >
        </nz-breadcrumb-item>
      </nz-breadcrumb>
    </div>
  </div>
</ng-template>
